import {Section, TextField} from "@radix-ui/themes";
import { MagnifyingGlassIcon } from "@radix-ui/react-icons"
import { useState } from "react";
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import {Em, Button} from "@radix-ui/themes";
import { Link } from "react-router-dom";
import MovieDrawer from "../MovieDrawer/MovieDrawer.js";

const Search = () => {
    const accessToken = process.env.REACT_APP_TMDB_ACCESS_TOKEN;
    const [results, setResults] = useState([]);
    const [query, setQuery] = useState('');
    const [openDrawerId, setOpenDrawerId] = useState('');
    const handleChange = (e) => {
        setQuery(e.target.value);
        fetchMovies(e.target.value);
    }
    const fetchMovies = async (query) => {
        try {
            const res = await axios.get(`https://api.themoviedb.org/3/search/movie?include_adult=false&language=en-US&page=1&query=${query}`, {
                headers: {
                    accept: 'application/json',
                    Authorization: `Bearer ${accessToken}`
                }
            });
            console.log("Response", res.data);
            const mostApplicableResults = [];
            for (let i = 0; i < res.data.results.length && i<14; i+=1) {
                const title = res.data.results[i].title;
                const og_title = res.data.results[i].original_title;
                const overview = res.data.results[i].overview;
            if ((title.toLowerCase().includes(query.toLowerCase()) ||
                og_title.toLowerCase().includes(query.toLowerCase()))) {
                mostApplicableResults.push(res.data.results[i]);
                continue;
            }
            if (overview.toLowerCase().includes(query.toLowerCase())) {
                mostApplicableResults.push(res.data.results[i]);
            }
        }
        setResults(mostApplicableResults);
        } catch (error) {
            console.error(error);
        }
    }
  return (
  <Section minHeight="100vh">
    <Link to="/">
              <img
                className="header_icon"
                src="https://upload.wikimedia.org/wikipedia/commons/c/cf/Movie_star_-_actor.svg"
                width="40"
                height="40"
                alt="logo"
              />
            </Link>
      <TextField.Root placeholder="Embark on a cinematic adventure..." size = "3" variant = "surface" value = {query} onChange={handleChange}>
        <TextField.Slot>
          <MagnifyingGlassIcon height="16" width="16" />
        </TextField.Slot>
      </TextField.Root>
      <List alignItems="center">
        {results.map((movie) => (
            <ListItem alignItems="center" variant = "outlined" onClick={() => setOpenDrawerId(movie.id)}>
                <Em>{movie.title}</Em>
                {openDrawerId === movie.id ? <MovieDrawer id={movie.id} /> : null}
            </ListItem>
        ))}
      </List>
    </Section>
    )
}

export default Search;
